import { DSButton } from "@components/design-system/molecules";

export function MultiSelectActionButton({
  onClick,
  onClickActionDescription,
  icon,
  variant = "primary",
  disabled = false,
}) {
  return (
    <DSButton
      disabled={disabled}
      onClick={onClick}
      icon={icon}
      variant={variant}
      size="sm"
      dataTestId={`multiselect-action-${onClickActionDescription?.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {onClickActionDescription}
    </DSButton>
  );
}
